export const language = {
	toolsUsedHeader: 'Tools',
};
